import { createApp } from 'vue';
import App from './App.vue';
import Router from './Router';
import Vant from 'vant';
import 'vant/lib/index.css';

const app = createApp(App);
app.use(Router);
app.use(Vant);
app.mount('#app');
